import React from "react";

import { Member } from "Models/members/member";
import { useTranslation } from "react-i18next";

import { ResourceIcons } from "../ResourceIcons";
import { TeamMember } from "./components/TeamMember";
import { TeamMembers, TeamMembersContainer, TeamMembersIcon } from "./styles";

interface ResourceTeamMembersProps {
  members: Member[];
}

export const ResourceTeamMembersCard: React.FC<ResourceTeamMembersProps> = ({ members }) => {
  const isEmpty = !members.length;
  const { t: translate } = useTranslation();

  return (
    <TeamMembersContainer isActive={!isEmpty}>
      <TeamMembersIcon>
        <ResourceIcons name="people" size={20} />
      </TeamMembersIcon>

      <TeamMembers isCentered={isEmpty || members.length === 1}>
        {isEmpty && translate("noStaffAdded")}

        {members.map((member) => {
          return (
            <TeamMember
              key={`${member.fullName}-${member.id}-member`}
              name={member?.fullName ?? member?.firstName}
              isSubcontractor={!!member.subcontractorId}
            />
          );
        })}
      </TeamMembers>
    </TeamMembersContainer>
  );
};
